import React from 'react';
import { connect } from 'react-redux';
import { Modal, Form, message, InputNumber } from 'antd';
import * as actionTypes from '../../redux/actions/seniormaster/actionTypes';
import { addCommission } from '../../redux/actions/seniormaster/addCommission';

const layout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 24 },
};

class AddCommissionModal extends React.Component {
    constructor(props) {
        super(props);
        this.form = React.createRef();
    }
    onFinish = async (values) => {
        await this.props.onAdd({
            id:this.props.smaster?.id,
            matchCount:values.matchCount,
            betCommission:values.betCommission,
            winCommission:values.winCommission
        },
            this.props.token);
        if (this.props.error) {
            message.error(this.props.error);
        }
        if (this.props.message) {
            message.success(this.props.message);
        }
        this.form.current.resetFields();
        this.props.onClose();
    }
    onFinishFailed = (errors) => {
        console.log(errors)
    }
    handleCancel = () => {
        this.props.onClose();
    }
    render() {
        return (
            <Modal
                title="Add Commission"
                key={this.props.commission?.id}
                centered
                visible={this.props.visible}
                okButtonProps={{ form: 'add-c-form', key: 'submit', htmlType: 'submit' }}
                confirmLoading={this.props.loading}
                onCancel={this.handleCancel}
                okText="Save"
                loading={this.props.loading}
            >
                <Form
                {...layout}
                    ref={this.form}
                    style={{ margin: 25 }}
                    id="add-c-form"
                    name="basic"
                    initialValues={{
                        matchCount:0,
                        betCommission:0,
                        winCommission:0
                    }}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    
                    <Form.Item
                        name="matchCount"
                        label="Match Count"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <InputNumber  style={{width:150}}/>
                    </Form.Item>
                    <Form.Item
                        name="betCommission"
                        label="Commission"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <InputNumber  style={{width:150}}/>
                    </Form.Item>
                    <Form.Item
                        name="winCommission"
                        label="Tax"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <InputNumber  style={{width:150}}/>
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    visible: state.seniorMaster.addCommissionVisible,
    loading: state.seniorMaster.loading,
    token: state.auth.token,
    error: state.seniorMaster.error,
    message: state.seniorMaster.message,
    smaster:state.seniorMaster.one,
})

const mapDispatchToProps = dispatch => ({
    onAdd: (obj, token) => dispatch(addCommission(obj, token)),
    onClose: () => dispatch({
        type:actionTypes.TOGGLE_ADD_COMMISSION_MODAL
    }),
})

export default connect(mapStateToProps, mapDispatchToProps)(AddCommissionModal);